module.exports = __webpack_public_path__ + "img/icon-ctn.f6bc3c3f.svg";